var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["widget-step", { active: _vm.isActiveStep }],
      attrs: { "data-test-id": "select-asset" }
    },
    [
      _c(
        "StepTitle",
        {
          attrs: { stepNumber: _vm.stepNumber },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("setStep", _vm.stepNumber)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "widget-step__title",
              attrs: { "data-test-id": "select-asset-title-container" }
            },
            [
              _c("p", { attrs: { "data-test-id": "select-asset-title" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.i18n.lbl_choose_asset()) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedAsset && !_vm.isActiveStep,
                      expression: "selectedAsset && !isActiveStep"
                    }
                  ],
                  attrs: { "data-test-id": "selected-asset" }
                },
                [_vm._v("\n        " + _vm._s(_vm.selectedAsset) + "\n      ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "AccordeonWrapper",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isActiveStep,
              expression: "isActiveStep"
            }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "widget-step__inner",
              attrs: { "data-test-id": "select-asset-container" }
            },
            [
              _c("SelectWrapper", {
                attrs: {
                  options: _vm.tokensCodeFormatted,
                  selected: _vm.selectedAsset,
                  "data-test-id": "select-asset-selector"
                },
                on: {
                  setSelected: function($event) {
                    return _vm.setSelectedAsset($event)
                  },
                  setOpen: function($event) {
                    return _vm.$emit("selectIsOpen", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "widget-step__swticher",
                  attrs: { "data-test-id": "select-asset-swtich-container" }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.i18n.white_wallet()))]),
                  _vm._v(" "),
                  _c("md-switch", {
                    attrs: {
                      disabled: !_vm.selectedAsset,
                      "data-test-id": "select-asset-swticher"
                    },
                    model: {
                      value: _vm.colorTronSwitch,
                      callback: function($$v) {
                        _vm.colorTronSwitch = $$v
                      },
                      expression: "colorTronSwitch"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.i18n.gray_wallet()))])
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f1f0f89", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f1f0f89","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/SelectAsset.vue
// module id = W1av
// module chunks = 1